import React from 'react';

import {default as DateTimeInput2} from '../DateTimeInput';

function DateTimeInput({label, values, onChange, invalid}) {
  const date = values.length > 0 ? new Date(parseInt(values[0].split(',')[0], 10)) : null;
  const offset = new Date().getTimezoneOffset() * 60 * 1000;

  return (
    <DateTimeInput2
      label={label}
      date={date}
      onChange={date => onChange([`${date.getTime()},${offset}`], true)}
      invalid={invalid}
    />
  );
}

export default DateTimeInput;
